import React from 'react';
import { PlusOutlined } from '@ant-design/icons';
import styled from 'styled-components';

type HistoryAddMoreCardProps = {
  active?: boolean;
  onClick?: () => void;
};

const HistoryAddMoreCard: React.FC<HistoryAddMoreCardProps> = ({ active, onClick }) => (
  <CardWrapper active={active} onClick={onClick}>
    <CardIcon>
      <PlusOutlined />
    </CardIcon>
    <CardLabel>Schedule Time Off</CardLabel>
  </CardWrapper>
);

export default HistoryAddMoreCard;

const CardWrapper = styled.div<{ active?: boolean }>`
  display: flex;
  align-items: center;
  gap: 10px;
  background: ${({ active }) => (active ? '#e6f4ff' : '#fff')};
  border-radius: 10px;
  border: 1px solid ${({ active }) => (active ? '#1677ff' : '#e8e8e8')};
  padding: 12px;
  margin-bottom: 10px;
  cursor: pointer;
  transition: all 0.15s ease;
  &:hover {
    background: ${({ active }) => (active ? '#d0e9ff' : '#f5f7ff')};
    border-color: ${({ active }) => (active ? '#1677ff' : '#91caff')};
  }
`;

const CardIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #e6f4ff;
  color: #1677ff;
  font-size: 16px;
`;

const CardLabel = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: #1677ff;
`;
